// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
  urlSearchParamsBodySerializer
} from './client'
import { client } from './client.gen'
import {
  authRefreshResponseTransformer,
  authTokenResponseTransformer,
  customersFindCustomersResponseTransformer,
  customersGetCustomerResponseTransformer,
  ordersGetCustomerOrdersResponseTransformer,
  ordersGetOrderDetailResponseTransformer,
  quotationsConfigurationTreeResponseTransformer,
  quotationsFindResponseTransformer,
  quotationsGetDoorListResponseTransformer,
  quotationsGetResponseTransformer,
  quotationsToDoorListResponseTransformer,
  quotationsValidateDoorListItemResponseTransformer
} from './transformers.gen'
import type {
  AuthConfigData,
  AuthConfigResponses,
  AuthRefreshData,
  AuthRefreshResponses,
  AuthTokenData,
  AuthTokenErrors,
  AuthTokenResponses,
  ConfigConfigData,
  ConfigConfigResponses,
  CustomersCreateCustomerAddressData,
  CustomersCreateCustomerAddressErrors,
  CustomersCreateCustomerAddressResponses,
  CustomersCreateCustomerRelationData,
  CustomersCreateCustomerRelationErrors,
  CustomersCreateCustomerRelationResponses,
  CustomersCreateInvoiceAddressData,
  CustomersCreateInvoiceAddressErrors,
  CustomersCreateInvoiceAddressResponses,
  CustomersDeleteCustomerAddressData,
  CustomersDeleteCustomerAddressErrors,
  CustomersDeleteCustomerAddressResponses,
  CustomersDeleteCustomerRelationData,
  CustomersDeleteCustomerRelationErrors,
  CustomersDeleteCustomerRelationResponses,
  CustomersFindCustomersData,
  CustomersFindCustomersErrors,
  CustomersFindCustomersResponses,
  CustomersGetCountryCodesData,
  CustomersGetCountryCodesResponses,
  CustomersGetCurrencyCodesData,
  CustomersGetCurrencyCodesResponses,
  CustomersGetCustomerAddressData,
  CustomersGetCustomerAddressErrors,
  CustomersGetCustomerAddressesData,
  CustomersGetCustomerAddressesErrors,
  CustomersGetCustomerAddressesResponses,
  CustomersGetCustomerAddressResponses,
  CustomersGetCustomerData,
  CustomersGetCustomerErrors,
  CustomersGetCustomerGroupsData,
  CustomersGetCustomerGroupsResponses,
  CustomersGetCustomerRelaionsQuoteData,
  CustomersGetCustomerRelaionsQuoteErrors,
  CustomersGetCustomerRelaionsQuoteResponses,
  CustomersGetCustomerRelationData,
  CustomersGetCustomerRelationErrors,
  CustomersGetCustomerRelationResponses,
  CustomersGetCustomerRelationsData,
  CustomersGetCustomerRelationsErrors,
  CustomersGetCustomerRelationsResponses,
  CustomersGetCustomerResponses,
  CustomersGetInvoiceAddressData,
  CustomersGetInvoiceAddressErrors,
  CustomersGetInvoiceAddressResponses,
  CustomersGetLanguageCodesData,
  CustomersGetLanguageCodesResponses,
  CustomersGetLobCodesData,
  CustomersGetLobCodesResponses,
  CustomersGetSalesChannelsData,
  CustomersGetSalesChannelsErrors,
  CustomersGetSalesChannelsResponses,
  CustomersUpdateCustomerAddressData,
  CustomersUpdateCustomerAddressErrors,
  CustomersUpdateCustomerAddressResponses,
  CustomersUpdateCustomerData,
  CustomersUpdateCustomerErrors,
  CustomersUpdateCustomerRelationData,
  CustomersUpdateCustomerRelationErrors,
  CustomersUpdateCustomerRelationResponses,
  CustomersUpdateCustomerResponses,
  CustomersUpdateInvoiceAddressData,
  CustomersUpdateInvoiceAddressErrors,
  CustomersUpdateInvoiceAddressResponses,
  OpsHealthCheckData,
  OpsHealthCheckResponses,
  OpsReadinessCheckData,
  OpsReadinessCheckErrors,
  OpsReadinessCheckResponses,
  OrdersGetCustomerOrdersData,
  OrdersGetCustomerOrdersErrors,
  OrdersGetCustomerOrdersResponses,
  OrdersGetOrderDetailData,
  OrdersGetOrderDetailErrors,
  OrdersGetOrderDetailResponses,
  OrdersGetOrdersData,
  OrdersGetOrdersErrors,
  OrdersGetOrdersResponses,
  OrdersGetOrderStatusesData,
  OrdersGetOrderStatusesResponses,
  QuotationsAddData,
  QuotationsAddDoorListItemData,
  QuotationsAddDoorListItemErrors,
  QuotationsAddDoorListItemResponses,
  QuotationsAddErrors,
  QuotationsAddResponses,
  QuotationsAddRulesetData,
  QuotationsAddRulesetErrors,
  QuotationsAddRulesetResponses,
  QuotationsBulkDeleteDoorListItemsData,
  QuotationsBulkDeleteDoorListItemsErrors,
  QuotationsBulkDeleteDoorListItemsResponses,
  QuotationsBulkUpdateDoorListItemsData,
  QuotationsBulkUpdateDoorListItemsErrors,
  QuotationsBulkUpdateDoorListItemsResponses,
  QuotationsConfigurationTreeData,
  QuotationsConfigurationTreeErrors,
  QuotationsConfigurationTreeResponses,
  QuotationsFindData,
  QuotationsFindErrors,
  QuotationsFindResponses,
  QuotationsGetAvailableRulesData,
  QuotationsGetAvailableRulesErrors,
  QuotationsGetAvailableRulesResponses,
  QuotationsGetData,
  QuotationsGetDoorListData,
  QuotationsGetDoorListErrors,
  QuotationsGetDoorListResponses,
  QuotationsGetErrors,
  QuotationsGetImportTableData,
  QuotationsGetImportTableErrors,
  QuotationsGetImportTableResponses,
  QuotationsGetResponses,
  QuotationsGetRulesetsData,
  QuotationsGetRulesetsErrors,
  QuotationsGetRulesetsResponses,
  QuotationsGetUploadedFileData,
  QuotationsGetUploadedFileErrors,
  QuotationsGetUploadedFileResponses,
  QuotationsImportFileData,
  QuotationsImportFileErrors,
  QuotationsImportFileResponses,
  QuotationsMostUsedFeaturesData,
  QuotationsMostUsedFeaturesErrors,
  QuotationsMostUsedFeaturesResponses,
  QuotationsRemoveDoorListItemData,
  QuotationsRemoveDoorListItemErrors,
  QuotationsRemoveDoorListItemResponses,
  QuotationsRemoveRulesetData,
  QuotationsRemoveRulesetErrors,
  QuotationsRemoveRulesetResponses,
  QuotationsRulesetPreviewData,
  QuotationsRulesetPreviewErrors,
  QuotationsRulesetPreviewResponses,
  QuotationsSetColumnVisibilityData,
  QuotationsSetColumnVisibilityErrors,
  QuotationsSetColumnVisibilityResponses,
  QuotationsToDoorListData,
  QuotationsToDoorListErrors,
  QuotationsToDoorListResponses,
  QuotationsToOrderData,
  QuotationsToOrderErrors,
  QuotationsToOrderResponses,
  QuotationsUpdateData,
  QuotationsUpdateDoorListItemData,
  QuotationsUpdateDoorListItemErrors,
  QuotationsUpdateDoorListItemResponses,
  QuotationsUpdateErrors,
  QuotationsUpdateImportOptionsData,
  QuotationsUpdateImportOptionsErrors,
  QuotationsUpdateImportOptionsResponses,
  QuotationsUpdateResponses,
  QuotationsUpdateRulesetData,
  QuotationsUpdateRulesetErrors,
  QuotationsUpdateRulesetResponses,
  QuotationsUploadData,
  QuotationsUploadErrors,
  QuotationsUploadResponses,
  QuotationsValidateDoorListItemData,
  QuotationsValidateDoorListItemErrors,
  QuotationsValidateDoorListItemResponses,
  QuotationsValidateRowData,
  QuotationsValidateRowErrors,
  QuotationsValidateRowResponses,
  UserMeData,
  UserMeResponses,
  UserUpdateProfileData,
  UserUpdateProfileErrors,
  UserUpdateProfileResponses
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

/**
 * Health Check
 *
 * Perform minimal/basic health check.
 *
 * Primarily for use in container orchestration frameworks as a liveness probe.
 */
export const opsHealthCheck = <ThrowOnError extends boolean = false>(
  options?: Options<OpsHealthCheckData, ThrowOnError>
): RequestResult<OpsHealthCheckResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OpsHealthCheckResponses, unknown, ThrowOnError>({
    url: '/health',
    ...options
  })

/**
 * Readiness Check
 *
 * Perform readiness checks against critical runtime dependencies.
 *
 * Primarily for use in container orchestration frameworks as a readiness probe.
 */
export const opsReadinessCheck = <ThrowOnError extends boolean = false>(
  options?: Options<OpsReadinessCheckData, ThrowOnError>
): RequestResult<OpsReadinessCheckResponses, OpsReadinessCheckErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    OpsReadinessCheckResponses,
    OpsReadinessCheckErrors,
    ThrowOnError
  >({ url: '/ready', ...options })

/**
 * Config
 *
 * Get configuration variables for authentication.
 */
export const authConfig = <ThrowOnError extends boolean = false>(
  options?: Options<AuthConfigData, ThrowOnError>
): RequestResult<AuthConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AuthConfigResponses, unknown, ThrowOnError>({
    url: '/auth/config',
    ...options
  })

/**
 * Token
 *
 * Return access token for a local account with email and password.
 */
export const authToken = <ThrowOnError extends boolean = false>(
  options: Options<AuthTokenData, ThrowOnError>
): RequestResult<AuthTokenResponses, AuthTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<AuthTokenResponses, AuthTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseTransformer: authTokenResponseTransformer,
    url: '/auth/token',
    ...options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...options.headers
    }
  })

/**
 * Refresh
 *
 * Exchange a refresh token for a new access token for a local account.
 *
 * Using the Double-Submit Cookie pattern.
 * So will only work if client (browser) allows 3rd party cookies.
 *
 * The refresh token should have been set in a secure,
 * httpOnly cookie by the authenticate endpoint.
 * Pass in the CSRF token as a X-CSRF-TOKEN header or as form data.
 */
export const authRefresh = <ThrowOnError extends boolean = false>(
  options?: Options<AuthRefreshData, ThrowOnError>
): RequestResult<AuthRefreshResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthRefreshResponses, unknown, ThrowOnError>({
    responseTransformer: authRefreshResponseTransformer,
    url: '/auth/refresh',
    ...options
  })

/**
 * Me
 *
 * Return authenticated user.
 */
export const userMe = <ThrowOnError extends boolean = false>(
  options?: Options<UserMeData, ThrowOnError>
): RequestResult<UserMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UserMeResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/user/me',
    ...options
  })

/**
 * Update Profile
 *
 * Update user profile.
 */
export const userUpdateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UserUpdateProfileData, ThrowOnError>
): RequestResult<UserUpdateProfileResponses, UserUpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UserUpdateProfileResponses,
    UserUpdateProfileErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/user/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Find
 *
 * Find quotations.
 */
export const quotationsFind = <ThrowOnError extends boolean = false>(
  options?: Options<QuotationsFindData, ThrowOnError>
): RequestResult<QuotationsFindResponses, QuotationsFindErrors, ThrowOnError> =>
  (options?.client ?? client).get<QuotationsFindResponses, QuotationsFindErrors, ThrowOnError>({
    responseTransformer: quotationsFindResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/',
    ...options
  })

/**
 * Add
 *
 * Add a quotation.
 */
export const quotationsAdd = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsAddData, ThrowOnError>
): RequestResult<QuotationsAddResponses, QuotationsAddErrors, ThrowOnError> =>
  (options.client ?? client).post<QuotationsAddResponses, QuotationsAddErrors, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get
 *
 * Return a quotation by id.
 */
export const quotationsGet = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetData, ThrowOnError>
): RequestResult<QuotationsGetResponses, QuotationsGetErrors, ThrowOnError> =>
  (options.client ?? client).get<QuotationsGetResponses, QuotationsGetErrors, ThrowOnError>({
    responseTransformer: quotationsGetResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}',
    ...options
  })

/**
 * Update
 *
 * Update a quotation.
 */
export const quotationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsUpdateData, ThrowOnError>
): RequestResult<QuotationsUpdateResponses, QuotationsUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<QuotationsUpdateResponses, QuotationsUpdateErrors, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * To Order
 *
 * Confirm quotation and create order.
 */
export const quotationsToOrder = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsToOrderData, ThrowOnError>
): RequestResult<QuotationsToOrderResponses, QuotationsToOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsToOrderResponses,
    QuotationsToOrderErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/order',
    ...options
  })

/**
 * Get Uploaded File
 *
 * Get uploaded file.
 */
export const quotationsGetUploadedFile = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetUploadedFileData, ThrowOnError>
): RequestResult<
  QuotationsGetUploadedFileResponses,
  QuotationsGetUploadedFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    QuotationsGetUploadedFileResponses,
    QuotationsGetUploadedFileErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/upload',
    ...options
  })

/**
 * Upload
 *
 * Upload an Excel spreadsheet (xslx).
 */
export const quotationsUpload = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsUploadData, ThrowOnError>
): RequestResult<QuotationsUploadResponses, QuotationsUploadErrors, ThrowOnError> =>
  (options.client ?? client).post<QuotationsUploadResponses, QuotationsUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers
    }
  })

/**
 * Update Import Options
 *
 * Update file import options.
 */
export const quotationsUpdateImportOptions = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsUpdateImportOptionsData, ThrowOnError>
): RequestResult<
  QuotationsUpdateImportOptionsResponses,
  QuotationsUpdateImportOptionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    QuotationsUpdateImportOptionsResponses,
    QuotationsUpdateImportOptionsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/upload/options',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Import File
 *
 * Import uploaded file.
 */
export const quotationsImportFile = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsImportFileData, ThrowOnError>
): RequestResult<QuotationsImportFileResponses, QuotationsImportFileErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsImportFileResponses,
    QuotationsImportFileErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/upload/process',
    ...options
  })

/**
 * Get Import Table
 *
 * Return imported table.
 */
export const quotationsGetImportTable = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetImportTableData, ThrowOnError>
): RequestResult<QuotationsGetImportTableResponses, QuotationsGetImportTableErrors, ThrowOnError> =>
  (options.client ?? client).get<
    QuotationsGetImportTableResponses,
    QuotationsGetImportTableErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/table',
    ...options
  })

/**
 * Set Column Visibility
 *
 * Set import table column visibility.
 */
export const quotationsSetColumnVisibility = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsSetColumnVisibilityData, ThrowOnError>
): RequestResult<
  QuotationsSetColumnVisibilityResponses,
  QuotationsSetColumnVisibilityErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsSetColumnVisibilityResponses,
    QuotationsSetColumnVisibilityErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/table/column-visibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Rulesets
 *
 * Return import table rule sets.
 */
export const quotationsGetRulesets = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetRulesetsData, ThrowOnError>
): RequestResult<QuotationsGetRulesetsResponses, QuotationsGetRulesetsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    QuotationsGetRulesetsResponses,
    QuotationsGetRulesetsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/ruleset',
    ...options
  })

/**
 * Add Ruleset
 *
 * Add rule set to import table.
 */
export const quotationsAddRuleset = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsAddRulesetData, ThrowOnError>
): RequestResult<QuotationsAddRulesetResponses, QuotationsAddRulesetErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsAddRulesetResponses,
    QuotationsAddRulesetErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/ruleset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Available Rules
 *
 * Return available rules for fields and feature combination.
 */
export const quotationsGetAvailableRules = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetAvailableRulesData, ThrowOnError>
): RequestResult<
  QuotationsGetAvailableRulesResponses,
  QuotationsGetAvailableRulesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsGetAvailableRulesResponses,
    QuotationsGetAvailableRulesErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/available-rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Ruleset Preview
 *
 * Return preview of applying given rule set.
 */
export const quotationsRulesetPreview = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsRulesetPreviewData, ThrowOnError>
): RequestResult<QuotationsRulesetPreviewResponses, QuotationsRulesetPreviewErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsRulesetPreviewResponses,
    QuotationsRulesetPreviewErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/ruleset-preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Remove Ruleset
 *
 * Remove rule set from import table.
 */
export const quotationsRemoveRuleset = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsRemoveRulesetData, ThrowOnError>
): RequestResult<QuotationsRemoveRulesetResponses, QuotationsRemoveRulesetErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    QuotationsRemoveRulesetResponses,
    QuotationsRemoveRulesetErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/ruleset/{ruleset_id}',
    ...options
  })

/**
 * Update Ruleset
 *
 * Overwrite existing rule set.
 */
export const quotationsUpdateRuleset = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsUpdateRulesetData, ThrowOnError>
): RequestResult<QuotationsUpdateRulesetResponses, QuotationsUpdateRulesetErrors, ThrowOnError> =>
  (options.client ?? client).put<
    QuotationsUpdateRulesetResponses,
    QuotationsUpdateRulesetErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/ruleset/{ruleset_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Configuration Tree
 *
 * Return configuration tree for a quotation.
 */
export const quotationsConfigurationTree = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsConfigurationTreeData, ThrowOnError>
): RequestResult<
  QuotationsConfigurationTreeResponses,
  QuotationsConfigurationTreeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    QuotationsConfigurationTreeResponses,
    QuotationsConfigurationTreeErrors,
    ThrowOnError
  >({
    responseTransformer: quotationsConfigurationTreeResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/feature-tree',
    ...options
  })

/**
 * Most Used Features
 *
 * Return the customer's most frequently mapped feature references.
 */
export const quotationsMostUsedFeatures = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsMostUsedFeaturesData, ThrowOnError>
): RequestResult<
  QuotationsMostUsedFeaturesResponses,
  QuotationsMostUsedFeaturesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    QuotationsMostUsedFeaturesResponses,
    QuotationsMostUsedFeaturesErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/most-used-features',
    ...options
  })

/**
 * Validate Row
 *
 * Validate row in import table using the configuration model.
 */
export const quotationsValidateRow = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsValidateRowData, ThrowOnError>
): RequestResult<QuotationsValidateRowResponses, QuotationsValidateRowErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsValidateRowResponses,
    QuotationsValidateRowErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/validate/{row}',
    ...options
  })

/**
 * To Door List
 *
 * Map import table into door list.
 *
 * Use the mapper configuration to transform the imported table into a door list.
 */
export const quotationsToDoorList = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsToDoorListData, ThrowOnError>
): RequestResult<QuotationsToDoorListResponses, QuotationsToDoorListErrors, ThrowOnError> =>
  (options.client ?? client).post<
    QuotationsToDoorListResponses,
    QuotationsToDoorListErrors,
    ThrowOnError
  >({
    responseTransformer: quotationsToDoorListResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/import/to-doorlist',
    ...options
  })

/**
 * Get Door List
 *
 * Get quotation door list.
 */
export const quotationsGetDoorList = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsGetDoorListData, ThrowOnError>
): RequestResult<QuotationsGetDoorListResponses, QuotationsGetDoorListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    QuotationsGetDoorListResponses,
    QuotationsGetDoorListErrors,
    ThrowOnError
  >({
    responseTransformer: quotationsGetDoorListResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/',
    ...options
  })

/**
 * Add Door List Item
 *
 * Add new item to door list.
 */
export const quotationsAddDoorListItem = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsAddDoorListItemData, ThrowOnError>
): RequestResult<
  QuotationsAddDoorListItemResponses,
  QuotationsAddDoorListItemErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsAddDoorListItemResponses,
    QuotationsAddDoorListItemErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Bulk Update Door List Items
 *
 * Bulk update existing door list items.
 *
 * Accepts mapping of item_id -> UpdateDoorListItem.
 *
 * Returns mapping of item_id -> updated DoorListItem.
 */
export const quotationsBulkUpdateDoorListItems = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsBulkUpdateDoorListItemsData, ThrowOnError>
): RequestResult<
  QuotationsBulkUpdateDoorListItemsResponses,
  QuotationsBulkUpdateDoorListItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsBulkUpdateDoorListItemsResponses,
    QuotationsBulkUpdateDoorListItemsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Bulk Delete Door List Items
 *
 * Bulk delete door list items.
 *
 * Accepts a list of IDs.
 */
export const quotationsBulkDeleteDoorListItems = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsBulkDeleteDoorListItemsData, ThrowOnError>
): RequestResult<
  QuotationsBulkDeleteDoorListItemsResponses,
  QuotationsBulkDeleteDoorListItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsBulkDeleteDoorListItemsResponses,
    QuotationsBulkDeleteDoorListItemsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items/bulk-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Remove Door List Item
 *
 * Remove door list item.
 */
export const quotationsRemoveDoorListItem = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsRemoveDoorListItemData, ThrowOnError>
): RequestResult<
  QuotationsRemoveDoorListItemResponses,
  QuotationsRemoveDoorListItemErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    QuotationsRemoveDoorListItemResponses,
    QuotationsRemoveDoorListItemErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items/{item_id}',
    ...options
  })

/**
 * Update Door List Item
 *
 * Update existing door list item.
 */
export const quotationsUpdateDoorListItem = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsUpdateDoorListItemData, ThrowOnError>
): RequestResult<
  QuotationsUpdateDoorListItemResponses,
  QuotationsUpdateDoorListItemErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    QuotationsUpdateDoorListItemResponses,
    QuotationsUpdateDoorListItemErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate Door List Item
 *
 * Validate door list item.
 */
export const quotationsValidateDoorListItem = <ThrowOnError extends boolean = false>(
  options: Options<QuotationsValidateDoorListItemData, ThrowOnError>
): RequestResult<
  QuotationsValidateDoorListItemResponses,
  QuotationsValidateDoorListItemErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    QuotationsValidateDoorListItemResponses,
    QuotationsValidateDoorListItemErrors,
    ThrowOnError
  >({
    responseTransformer: quotationsValidateDoorListItemResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/quotations/{id}/doorlist/items/{item_id}/validate',
    ...options
  })

/**
 * Find Customers
 *
 * Find customers.
 */
export const customersFindCustomers = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersFindCustomersData, ThrowOnError>
): RequestResult<CustomersFindCustomersResponses, CustomersFindCustomersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    CustomersFindCustomersResponses,
    CustomersFindCustomersErrors,
    ThrowOnError
  >({
    responseTransformer: customersFindCustomersResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/',
    ...options
  })

/**
 * Get Customer Relaions Quote
 *
 * Get all customer relations across all customers.
 */
export const customersGetCustomerRelaionsQuote = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetCustomerRelaionsQuoteData, ThrowOnError>
): RequestResult<
  CustomersGetCustomerRelaionsQuoteResponses,
  CustomersGetCustomerRelaionsQuoteErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    CustomersGetCustomerRelaionsQuoteResponses,
    CustomersGetCustomerRelaionsQuoteErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/relations',
    ...options
  })

/**
 * Get Customer
 *
 * Get a customer.
 */
export const customersGetCustomer = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetCustomerData, ThrowOnError>
): RequestResult<CustomersGetCustomerResponses, CustomersGetCustomerErrors, ThrowOnError> =>
  (options.client ?? client).get<
    CustomersGetCustomerResponses,
    CustomersGetCustomerErrors,
    ThrowOnError
  >({
    responseTransformer: customersGetCustomerResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}',
    ...options
  })

/**
 * Update Customer
 *
 * Update a customer.
 */
export const customersUpdateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<CustomersUpdateCustomerData, ThrowOnError>
): RequestResult<CustomersUpdateCustomerResponses, CustomersUpdateCustomerErrors, ThrowOnError> =>
  (options.client ?? client).put<
    CustomersUpdateCustomerResponses,
    CustomersUpdateCustomerErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Customer Addresses
 *
 * Get a customer's addresses.
 */
export const customersGetCustomerAddresses = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetCustomerAddressesData, ThrowOnError>
): RequestResult<
  CustomersGetCustomerAddressesResponses,
  CustomersGetCustomerAddressesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomersGetCustomerAddressesResponses,
    CustomersGetCustomerAddressesErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/addresses',
    ...options
  })

/**
 * Create Customer Address
 *
 * Create a new address for a customer.
 */
export const customersCreateCustomerAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersCreateCustomerAddressData, ThrowOnError>
): RequestResult<
  CustomersCreateCustomerAddressResponses,
  CustomersCreateCustomerAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomersCreateCustomerAddressResponses,
    CustomersCreateCustomerAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/addresses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete Customer Address
 *
 * Delete a customer address.
 */
export const customersDeleteCustomerAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersDeleteCustomerAddressData, ThrowOnError>
): RequestResult<
  CustomersDeleteCustomerAddressResponses,
  CustomersDeleteCustomerAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    CustomersDeleteCustomerAddressResponses,
    CustomersDeleteCustomerAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/addresses/{address_id}',
    ...options
  })

/**
 * Get Customer Address
 *
 * Get a specific customer address by ID.
 */
export const customersGetCustomerAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetCustomerAddressData, ThrowOnError>
): RequestResult<
  CustomersGetCustomerAddressResponses,
  CustomersGetCustomerAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomersGetCustomerAddressResponses,
    CustomersGetCustomerAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/addresses/{address_id}',
    ...options
  })

/**
 * Update Customer Address
 *
 * Update an existing address for a customer.
 */
export const customersUpdateCustomerAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersUpdateCustomerAddressData, ThrowOnError>
): RequestResult<
  CustomersUpdateCustomerAddressResponses,
  CustomersUpdateCustomerAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CustomersUpdateCustomerAddressResponses,
    CustomersUpdateCustomerAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/addresses/{address_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Customer Relations
 *
 * Get a customer's relations.
 */
export const customersGetCustomerRelations = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetCustomerRelationsData, ThrowOnError>
): RequestResult<
  CustomersGetCustomerRelationsResponses,
  CustomersGetCustomerRelationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomersGetCustomerRelationsResponses,
    CustomersGetCustomerRelationsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/relations',
    ...options
  })

/**
 * Create Customer Relation
 *
 * Create a new customer relation.
 */
export const customersCreateCustomerRelation = <ThrowOnError extends boolean = false>(
  options: Options<CustomersCreateCustomerRelationData, ThrowOnError>
): RequestResult<
  CustomersCreateCustomerRelationResponses,
  CustomersCreateCustomerRelationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomersCreateCustomerRelationResponses,
    CustomersCreateCustomerRelationErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/relations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete Customer Relation
 *
 * Delete a customer relation.
 */
export const customersDeleteCustomerRelation = <ThrowOnError extends boolean = false>(
  options: Options<CustomersDeleteCustomerRelationData, ThrowOnError>
): RequestResult<
  CustomersDeleteCustomerRelationResponses,
  CustomersDeleteCustomerRelationErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    CustomersDeleteCustomerRelationResponses,
    CustomersDeleteCustomerRelationErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/relations/{relation_id}',
    ...options
  })

/**
 * Get Customer Relation
 *
 * Get a specific customer relation by ID.
 */
export const customersGetCustomerRelation = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetCustomerRelationData, ThrowOnError>
): RequestResult<
  CustomersGetCustomerRelationResponses,
  CustomersGetCustomerRelationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomersGetCustomerRelationResponses,
    CustomersGetCustomerRelationErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/relations/{relation_id}',
    ...options
  })

/**
 * Update Customer Relation
 *
 * Update an existing customer relation.
 */
export const customersUpdateCustomerRelation = <ThrowOnError extends boolean = false>(
  options: Options<CustomersUpdateCustomerRelationData, ThrowOnError>
): RequestResult<
  CustomersUpdateCustomerRelationResponses,
  CustomersUpdateCustomerRelationErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CustomersUpdateCustomerRelationResponses,
    CustomersUpdateCustomerRelationErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/relations/{relation_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Invoice Address
 *
 * Get customer's invoice address.
 */
export const customersGetInvoiceAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersGetInvoiceAddressData, ThrowOnError>
): RequestResult<
  CustomersGetInvoiceAddressResponses,
  CustomersGetInvoiceAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomersGetInvoiceAddressResponses,
    CustomersGetInvoiceAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/invoice-address',
    ...options
  })

/**
 * Create Invoice Address
 *
 * Create customer's invoice address.
 */
export const customersCreateInvoiceAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersCreateInvoiceAddressData, ThrowOnError>
): RequestResult<
  CustomersCreateInvoiceAddressResponses,
  CustomersCreateInvoiceAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomersCreateInvoiceAddressResponses,
    CustomersCreateInvoiceAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/invoice-address',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update Invoice Address
 *
 * Update customer's invoice address.
 */
export const customersUpdateInvoiceAddress = <ThrowOnError extends boolean = false>(
  options: Options<CustomersUpdateInvoiceAddressData, ThrowOnError>
): RequestResult<
  CustomersUpdateInvoiceAddressResponses,
  CustomersUpdateInvoiceAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CustomersUpdateInvoiceAddressResponses,
    CustomersUpdateInvoiceAddressErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/{customer_id}/invoice-address',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get Sales Channels
 *
 * Get available sales channels.
 */
export const customersGetSalesChannels = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetSalesChannelsData, ThrowOnError>
): RequestResult<
  CustomersGetSalesChannelsResponses,
  CustomersGetSalesChannelsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    CustomersGetSalesChannelsResponses,
    CustomersGetSalesChannelsErrors,
    ThrowOnError
  >({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/sales-channels',
    ...options
  })

/**
 * Get Language Codes
 *
 * Get available language codes.
 */
export const customersGetLanguageCodes = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetLanguageCodesData, ThrowOnError>
): RequestResult<CustomersGetLanguageCodesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomersGetLanguageCodesResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/language-codes',
    ...options
  })

/**
 * Get Country Codes
 *
 * Get available country codes.
 */
export const customersGetCountryCodes = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetCountryCodesData, ThrowOnError>
): RequestResult<CustomersGetCountryCodesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomersGetCountryCodesResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/country-codes',
    ...options
  })

/**
 * Get Customer Groups
 *
 * Get available customer groups.
 */
export const customersGetCustomerGroups = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetCustomerGroupsData, ThrowOnError>
): RequestResult<CustomersGetCustomerGroupsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomersGetCustomerGroupsResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/customer-groups',
    ...options
  })

/**
 * Get Currency Codes
 *
 * Get available currency codes.
 */
export const customersGetCurrencyCodes = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetCurrencyCodesData, ThrowOnError>
): RequestResult<CustomersGetCurrencyCodesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomersGetCurrencyCodesResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/currency-codes',
    ...options
  })

/**
 * Get Lob Codes
 *
 * Get available LOB codes.
 */
export const customersGetLobCodes = <ThrowOnError extends boolean = false>(
  options?: Options<CustomersGetLobCodesData, ThrowOnError>
): RequestResult<CustomersGetLobCodesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomersGetLobCodesResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/customers/lists/lob-codes',
    ...options
  })

/**
 * Get Customer Orders
 *
 * Get customer orders by customer ID.
 */
export const ordersGetCustomerOrders = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersGetCustomerOrdersData, ThrowOnError>
): RequestResult<OrdersGetCustomerOrdersResponses, OrdersGetCustomerOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    OrdersGetCustomerOrdersResponses,
    OrdersGetCustomerOrdersErrors,
    ThrowOnError
  >({
    responseTransformer: ordersGetCustomerOrdersResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/orders/views/customer',
    ...options
  })

/**
 * Get Order Statuses
 *
 * Get available order statuses.
 */
export const ordersGetOrderStatuses = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersGetOrderStatusesData, ThrowOnError>
): RequestResult<OrdersGetOrderStatusesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrdersGetOrderStatusesResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/orders/lists/order-statuses',
    ...options
  })

/**
 * Get Orders
 *
 * Get orders for internal employees.
 */
export const ordersGetOrders = <ThrowOnError extends boolean = false>(
  options?: Options<OrdersGetOrdersData, ThrowOnError>
): RequestResult<OrdersGetOrdersResponses, OrdersGetOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<OrdersGetOrdersResponses, OrdersGetOrdersErrors, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/orders',
    ...options
  })

/**
 * Get Order Detail
 *
 * Get order detail for internal employees.
 */
export const ordersGetOrderDetail = <ThrowOnError extends boolean = false>(
  options: Options<OrdersGetOrderDetailData, ThrowOnError>
): RequestResult<OrdersGetOrderDetailResponses, OrdersGetOrderDetailErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OrdersGetOrderDetailResponses,
    OrdersGetOrderDetailErrors,
    ThrowOnError
  >({
    responseTransformer: ordersGetOrderDetailResponseTransformer,
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/orders/{customer_id}/{order_id}',
    ...options
  })

/**
 * Config
 *
 * Get configuration values.
 */
export const configConfig = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigConfigData, ThrowOnError>
): RequestResult<ConfigConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ConfigConfigResponses, unknown, ThrowOnError>({
    security: [
      {
        key: 'Entra_ID',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'OAuth2PasswordBearer',
        scheme: 'bearer',
        type: 'http'
      },
      {
        key: 'HTTPBearer',
        scheme: 'bearer',
        type: 'http'
      }
    ],
    url: '/v1/config/',
    ...options
  })
